import React from 'react';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

type SearchProps = {};

export const TagsManagement: React.FC<SearchProps> = (props) => {

  return (
    <>
      <Typography sx={{ margin: 1, }} variant="h4" gutterBottom>
        体系・分野管理
      </Typography>
      <Paper sx={{
        minWidth: 275,
        width: '95%',
        margin: 2,
        padding: 1,
        backgroundColor: (theme) => theme.palette.primary[50],
      }} elevation={3}>
        <Typography variant="h5">
          体系目次
        </Typography>
        <div>
          <List sx={{ '-khtml-user-drag': 'element', }}>
            <div draggable="true">
              <ListItemButton>
                <ListItemText primary={'a'} />
              </ListItemButton>
            </div>
            <div draggable="true">
              <ListItemButton>
                <ListItemText primary={'b'} />
              </ListItemButton>
            </div>
            <div draggable="true">
              <ListItemButton>
                <ListItemText primary={'c'} />
              </ListItemButton>
            </div>
          </List>
        </div>
      </Paper>
    </>
  );
};